module.exports = __webpack_public_path__ + "media/Video 82b.bca6e7da.mp4";